<template>
  <div class="header-page">
    <!-- container-fluid -->
    <div class="my-header">
      <!-- Content here -->
      <!-- navbar-dark bg-dark -->
      <nav>
        <div class="container">
          <div class="nav-box">
            <a class="logo" href="#">
              <img src="../assets/image/home/logo.png" alt="" />
            </a>
            <ul class="list">
              <li
                class="item"
                v-for="(item, index) in navList"
                :class="{ active: tabIndex === index }"
                @click="changeTab(index)"
                :key="item.id"
              >
                <router-link :to="item.link" class="link">
                  {{ item.desc }}</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isNavOpen: false,
      isSticky: false,
      tabIndex: 0,
      navList: [
        {
          id: "tab1",
          desc: "首页",
          link: "/homePage",
        },
        {
          id: "tab2",
          desc: "品牌介绍",
          link: "/brand",
        },
        {
          id: "tab3",
          desc: "招商加盟",
          link: "/joinUs",
        },
        {
          id: "tab4",
          desc: "媒体中心",
          link: "/news",
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      switch (to.path) {
        case "/homePage":
          this.tabIndex = 0;
          break;
        case "/brand":
          this.tabIndex = 1;
          break;
        case "/joinUs":
          this.tabIndex = 2;
          break;
        case "/news":
          this.tabIndex = 3;
          break;
        case "/hotelScene":
          this.tabIndex = 2;
          break;
      }
    },
  },
  methods: {
    changeTab(index) {
      this.tabIndex = index;
    },
    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
    },
    handleScroll() {
      this.isSticky = window.pageYOffset > 0;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
@media (max-width: 1400px) {
  .link {
    font-size: 0.8vw !important;
  }
}
.header-page {
  background-color: #000;
  width: 100%;
}
.my-header {
  background-color: #000;
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999999;
}
.nav-box {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  .logo {
    width: 4.17%;
    margin-left: 5%;
    margin-right: 30%;
  }

  .list {
    display: flex;
    justify-content: space-around;
    .item {
      // padding: 1vw;

      .link {
        display: block;
        padding: 1vw;
        color: #fff;
      }
    }
    .item:hover .link {
      color: rgb(255, 101, 42);
      cursor: pointer;
    }
    .active {
      border-bottom: 3px solid rgb(255, 101, 42);
    }
  }
}
@media (min-width: 1980px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1920px;
    width: 1920px;
    padding: 0;
  }
}
</style>